<template>
    <table class="soil-report-results m-t-15">
        <thead>
            <tr>
                <th colspan="13" class="border-0 bg-transparent"></th>
                <th colspan="10" class="bg-transparent">DTPA Extraction</th>
                <th colspan="3" class="border-0 bg-transparent"></th>
            </tr>
            <tr>
                <th rowspan="5">SAMPLE<br>ID</th>
                <th colspan="10">NITRATE-N (FIA)</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">SULFUR<br>S</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">ZINC<br>Zn</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">MANGANESE<br>Mn</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">IRON<br>Fe</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">COPPER<br>Cu</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">BORON<br>B</th>
                <th rowspan="3" class="border-bottom-0">EXCESS<br>LIME</th>
                <th rowspan="2" colspan="2" class="border-bottom-0">SOLUBLE<br>SALTS</th>
                <th rowspan="3" class="border-bottom-0" v-show="showMehlichP">MEHLICH P</th>
            </tr>

            <tr>
                <th colspan="3" class="border-bottom-0">Surface</th>
                <th colspan="3" class="border-bottom-0">Sub 1</th>
                <th colspan="3" class="border-bottom-0">Sub 2</th>
                <th class="border-bottom-0">Total</th>
            </tr>

            <tr>
                <template v-for="n in 3">
                    <th rowspan="2" class="border-top-0 border-right-0 align-bottom">ppm</th>
                    <th rowspan="2" class="border-top-0 border-left-0 border-right-0 align-bottom">lbs/A</th>
                    <th rowspan="2" class="border-top-0 border-left-0 align-bottom">depth<br>IN</th>
                </template>
                <th rowspan="2" class="border-top-0  align-bottom">lbs/A</th>
                <template v-for="n in 6">
                    <th rowspan="2" class="border-top-0 border-right-0  align-bottom">ppm</th>
                    <th rowspan="2" class="border-top-0 border-left-0  align-bottom">RATE</th>
                </template>
                <th colspan="2" class="border-top-0 border-bottom-0">1:1</th>
            </tr>

            <tr>
                <th class="border-top-0 align-bottom">RATE</th>
                <th class="border-top-0 border-right-0  align-bottom">mmhos/cm</th>
                <th class="border-top-0 border-left-0  align-bottom">RATE</th>
                <th class="border-top-0 align-bottom" v-show="showMehlichP">ppm</th>
            </tr>
        </thead>

        <tbody>
            <tr class="text-center" v-for="(sample, sample_index) in samples">
                <td>{{ sample.client_id || '&nbsp;' }}</td>
                <td>{{ getResult(sample_index, 'NO3') }}</td>
                <td>{{ getResult(sample_index, 'NO3_LBS') }}</td>
                <td>{{ getResult(sample_index, 'Depth') }}</td>
                <td>{{ getResult(sample_index, 'sub1_NO3') }}</td>
                <td>{{ getResult(sample_index, 'sub1_NO3_LBS') }}</td>
                <td>{{ getResult(sample_index, 'Sub 1 Depth') }}</td>
                <td>{{ getResult(sample_index, 'sub2_NO3') }}</td>
                <td>{{ getResult(sample_index, 'sub2_NO3_LBS') }}</td>
                <td>{{ getResult(sample_index, 'Sub 2 Depth') }}</td>
                <td>{{ calculateTotalNitrateLbsPerActre(sample_index) }}</td>
                <td>{{ getResult(sample_index, 'S') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'S Rate') }}</td>
                <td>{{ getResult(sample_index, 'ZN') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'ZN Rate') }}</td>
                <td>{{ getResult(sample_index, 'MN') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'MN Rate') }}</td>
                <td>{{ getResult(sample_index, 'FE') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'FE Rate') }}</td>
                <td>{{ getResult(sample_index, 'CU') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'CU Rate') }}</td>
                <td>{{ getResult(sample_index, 'B') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'B Rate') }}</td>
                <td>{{ getResult(sample_index, 'EXCESS_LIME') }}</td>
                <td>{{ getResult(sample_index, 'SOLSALTS') }}</td>
                <td class="bg-primary-color">{{ getResult(sample_index, 'SOLSALTS Rate') }}</td>
                <td v-show="showMehlichP">{{ getResult(sample_index, 'MEHLICHP_COLOR') }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script type="text/ecmascript-6">
export default {
    props: {
        samples: { default() { return [] } }
    },
    data() {
        return {

        }
    },
    computed: {
        showMehlichP() {
            const { samples } = this;
            return samples.filter(sample => _.get(sample, ['MEHLICHP_COLOR', 'value'])).length > 0;
        }
    },
    methods: {
        getResult(sample_index, analysis) {
            const { samples } = this;
            return _.get(samples, [sample_index, analysis, 'value']);
        },
        calculateTotalNitrateLbsPerActre(sample_index) {
            return [
                this.getResult(sample_index, 'NO3_LBS'),
                this.getResult(sample_index, 'sub1_NO3_LBS'),
                this.getResult(sample_index, 'sub2_NO3_LBS')
            ]
                .filter(no3 => no3)
                .reduce((sum, value) => {
                    return sum + parseFloat(value)
                }, 0)
        }
    },
    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// ResultsTable2.vue?0304ecde